import React from "react";
import { unGlobalCompactPrinciplesColDefs } from "../column-definition";
import { InsTable } from "../insTable";
import styles from "./insUNGlobalCompactPrinciplesWidget.module.scss";
export const InsPrinciplesSection = ({ category, hasHeader, rowData }) => React.createElement(React.Fragment, null,
    React.createElement("div", { className: styles.principleCategory }, category),
    React.createElement(InsTable, { columnDefs: unGlobalCompactPrinciplesColDefs, hasHeader: hasHeader, rowData: rowData }));
